<template>
  <v-dialog
    v-model="opened"
    content-class="investor-dialog"
    max-width="370"
    persistent
  >
    <header>
      <h3 class="investor-dialog__title">
        {{ title }}
      </h3>

      <v-btn class="close-btn" icon @click="opened = false">
        <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
      </v-btn>
    </header>

    <transaction-form
      :investor-id="item.id"
      :top-up="topUp"
      :opened="opened"
      @updated="$emit('updated', $event)"
    />
  </v-dialog>
</template>

<script>
import TransactionForm from './TransactionForm.vue';

export default {
  components: { TransactionForm },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      required: true,
    },
    topUp: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      const action = this.topUp
        ? this.$t('investor-report.top-up')
        : this.$t('investor-report.pay');

      return `${action}: ${this.item.user?.name}`;
    },
  },
};
</script>

<style lang="scss">
.investor-dialog {
  padding: 10px;
  background-color: #fff;

  &__title {
    font-size: 16px;
    color: #424242;
    margin-bottom: 20px;
    margin-top: 3px;
    line-height: 1.2;
  }

  header {
    padding-right: 25px;
  }
}
</style>
